 <template>
  <div id="app">
    <!-- Navigation-->
    <nav class="navbar navbar-expand-lg navbar-dark bg-default fixed-top" id="mainNav">
      <b-button 
        v-b-toggle.menuCollapsed 
        class="navbar-toggler navbar-toggler-right"
        >
        <span class="navbar-toggler-icon"></span>
      </b-button >
        
      <b-collapse id="menuCollapsed" class="navbar-collapse o-hidden">

        <h2 class="color-white">Comprodonto</h2>

        <h3 class="color-white" style="margin-left: 3%; margin-bottom: 3px;">{{ nomeUsuario }}</h3>

        <ul class="navbar-nav navbar-sidenav">
          
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
            <router-link class="nav-link" to="/adm/dashboard">
              <i class="fa fa-fw fa-dashboard"></i>
              <span class="nav-link-text"> Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Informações">
            <router-link class="nav-link" to="/adm/uniodontos">
              <i class="fa fa-fw fa-info"></i>
              <span class="nav-link-text"> Uniodontos</span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Bookings">
            <router-link  class="nav-link" to="/adm/usuarios">
              <i class="fa fa-fw fa-users"></i>
              <span class="nav-link-text"> Usuários
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Messages">
            <router-link class="nav-link" to="/adm/planos">
              <i class="fa fa-fw fa-envelope-open"></i>
              <span class="nav-link-text"> Planos</span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Bookings">
            <router-link  class="nav-link" to="/adm/assinantes">
              <i class="fa fa-fw fa-calendar-check-o"></i>
              <span class="nav-link-text"> Assinantes
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Titulares">
            <router-link  class="nav-link" to="/adm/titulares">
              <i class="fa fa-fw fa-user-circle-o"></i>
              <span class="nav-link-text"> Titulares
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dependentes">
            <router-link  class="nav-link" to="/adm/dependentes">
              <i class="fa fa-fw fa-user-o"></i>
              <span class="nav-link-text"> Dependentes
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Bookings">
            <router-link  class="nav-link" to="/adm/carrinho">
              <i class="fa fa-fw fa-shopping-cart"></i>
              <span class="nav-link-text"> Carrinho
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Cupons">
            <router-link  class="nav-link" to="/adm/cupons">
                <i class="fa fa-certificate"></i>
              <span class="nav-link-text"> Cupons
             
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Cupons">
            <router-link  class="nav-link" to="/adm/leads">
                <i class="fa fa-id-badge"></i>
              <span class="nav-link-text"> Leads
             
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Cupons">
            <router-link  class="nav-link" to="/adm/eventos">
                <i class="fa fa-fw fa-calendar-check-o"></i>
              <span class="nav-link-text"> Eventos
             
              </span>
            </router-link>
          </li>
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Cupons">
            <router-link  class="nav-link" to="/adm/empresas">
              <i class="fa fa-fw fa-solid fa-building"></i>
              <span class="nav-link-text"> Empresas
             
              </span>
            </router-link>
          </li>

          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Planilhas">
            <router-link  class="nav-link" to="/adm/planilhas" >
              <i class="fa fa-fw fa-list-alt"></i>
              <span class="nav-link-text"> Planilhas
              </span>
            </router-link>
          </li> -->

          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Usuários">
            <router-link  class="nav-link" to="/adm/usuarios" >
              <i class="fa fa-fw fa-user"></i>
              <span class="nav-link-text"> Usuários
              </span>
            </router-link>
          </li> -->

          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Notificação">
            <router-link  class="nav-link" to="/adm/notificacao" >
              <i class="fa fa-fw fa-envelope-o"></i>
              <span class="nav-link-text"> Notificação
              </span>
            </router-link>
          </li> -->
<!-- 
          <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Banners">
            <router-link  class="nav-link" to="/adm/banners" >
              <i class="fa fa-fw fa-picture-o"></i>
              <span class="nav-link-text"> Banners
              </span>
            </router-link>
          </li> -->

          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Cidades">
            <router-link  class="nav-link" to="/adm/cidades" >
              <i class="fa fa-fw fa-map-marker"></i>
              <span class="nav-link-text"> Cidades
              </span>
            </router-link>
          </li> -->

          <!-- <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Pagamentos">
            <router-link  class="nav-link" to="/adm/forma-pagamentos" >
              <i class="fa fa-fw fa-money"></i>
              <span class="nav-link-text"> Formas de pagamentos
              </span>
            </router-link>
          </li> -->

        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" @click="logOut();">
              <i class="fa fa-fw fa-sign-out"></i>Logout
            </a>
          </li>
        </ul>
      </b-collapse>
    </nav>
    <!-- /Navigation-->


    <!-- Conteudo-->
    <router-view />
    <!-- /Conteudo-->


    <!-- <footer class="sticky-footer">
      <div class="container">
        <div class="text-center">
          <small>Copyright © MazeApps 2019</small>
        </div>
      </div>
    </footer> -->
  </div>
</template>
<script>
import { verificaSeEstaLogado } from "../../utils/util";

export default {
  data() {
    return {
      logado: false,
      nomeUsuario: '',
      collapseMenu: false,
      expandDistribuidoras: false,
      expandPrestadoras: false,
      classMenu: 'navbar-collapse collapse',
    };
  },
  mounted() {
    var self = this;
    var user = verificaSeEstaLogado();
    if(user){
      self.logado = true;
      self.nomeUsuario = user.name;
    }else{
      self.logado = false;
    }
  },
  methods: {
      logOut(){
        localStorage.removeItem("token_adm_comprodonto");
        this.$router.push('/')
      }
    },
}
</script>
<style scoped>

@media (min-width: 992px){
  #mainNav.fixed-top .navbar-sidenav {
      height: calc(100vh);
  }
}

#logo {
    height: 60px;
    position: absolute;
    margin-left: -35px;
    margin-top: 5px;
}
</style>
